/*
 * @Description: 文件内容
 * @Author: dali
 * @Date: 2021-03-27 14:09:45
 * @LastEditors: dali
 * @LastEditTime: 2022-09-26 16:59:06
 */
import React, { Fragment } from 'react'
import { useRoutes } from 'react-router-dom'
import { routes } from '@/route'

function App() {
  return (
    <Fragment>
      {useRoutes(routes)}
    </Fragment>
  )
}

export default App
